// import React, { useEffect, useRef, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const AddBrokerModal = ({ BrokerDataFetchFunc }) => {

//   const fileInputRef = useRef(null);

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem("user"))?.id;
//       console.log("id", id);
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${
//             JSON.parse(sessionStorage.getItem("user")).accessToken
//           }`,
//         },
//       });

//       console.log("response", response);
//     } catch (error) {
//       return error;
//     }
//   };

//   useEffect(() => {
//     AllFileLoginData();
//   }, []);

//   const [radioValue, setRadioValue] = useState(false);

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({
//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     // Purpose: Number,
//     IsPurposeMet: false,
//     LoanNumber: "",
//     Selfie: null,
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setLocalFormData({ ...LocalFormData, Selfie: file });
//   };

//   const handleRadioChange = (e) => {
//     setRadioValue(e.target.value === "true");
//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setLocalFormData({
//           ...LocalFormData,
//           Latitude: latitude,
//           Longitude: longitude,
//         });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, []);

//   // console.log("location",location?.latitude)

//   const HandleSubmit = async () => {
//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     // formData.append("Purpose", LocalFormData.Purpose);
//     formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
//     formData.append("LoanNumber", LocalFormData.LoanNumber);
//     formData.append("Selfie", LocalFormData.Selfie);
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     }
//     // console.log(LocalFormData)
//     try {
//       const response = await axios.post(
//         `${Api_Url}api/v1/BrokerVisit`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       BrokerDataFetchFunc();
//       resetForm()
//       SuccessToast("Broker Data Submiitted Successfully")
//       console.log(response);
//     } catch (error) {
//       return error.message;
//     }
//   };

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//       Name: "",
//       Mobile: "",
//       // Purpose: Number,
//       IsPurposeMet: false,
//       LoanNumber: "",
//       Selfie: null,
//     });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const [allbranch, setAllBranch] = useState("");

//   const AllBranchName = async () => {
//     try {
//       const response = await axios.get(
//         `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//           headers: {
//             Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           }
//         }
//       );
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data);
//     } catch (error) {
//       console.log("object", error);
//     }
//   };
//   console.log(allbranch);

//   useEffect(() => {
//     AllBranchName();
//   }, []);

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div
//         id="add_client"
//         className="modal custom-modal fade"
//         role="dialog"
//         data-bs-backdrop="static"
//         data-bs-keyboard="false"
//       >
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Broker Visit</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src={AllFormsUpperphoto}
//                   alt="mohit"
//                   className="img-fluid rounded-circle"
//                   style={{ width: "100px", height: "100px" }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             BranchId: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch &&
//                           allbranch.length > 0 &&
//                           allbranch.map((res) => (
//                             <option value={res.id}>{res.name}</option>
//                           ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Customer Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.Name}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             Name: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">
//                       Upload Document <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       accept="image/*"
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         value={LocalFormData.Mobile}
//                         onChange={handleMobileChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Loan No.<span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.LoanNumber}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             LoanNumber: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Purpose Met <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsPurposeMet === true}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsPurposeMet: e.target.value === "true",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault1"
//                       >
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={LocalFormData.IsPurposeMet === false}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsPurposeMet: e.target.value === "true",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault2"
//                       >
//                         No
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="Barry"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name</label>
//                       <input
//                         className="form-control"
//                         defaultValue="Cuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Username <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="barrycuda@example.com"
//                         type="email"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Confirm Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Client ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="CLT-0001"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Phone </label>
//                       <input
//                         className="form-control"
//                         defaultValue={9876543210}
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Company Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Global Technologies"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="table-responsive m-t-15">
//                   <table className="table table-striped custom-table">
//                     <thead>
//                       <tr>
//                         <th>Module Permission</th>
//                         <th className="text-center">Read</th>
//                         <th className="text-center">Write</th>
//                         <th className="text-center">Create</th>
//                         <th className="text-center">Delete</th>
//                         <th className="text-center">Import</th>
//                         <th className="text-center">Export</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData.map((row, index) => (
//                         <tr key={index}>
//                           <td>{row.module}</td>
//                           {[
//                             "read",
//                             "write",
//                             "create",
//                             "delete",
//                             "import",
//                             "export",
//                           ].map((column) => (
//                             <td key={column} className="text-center">
//                               <label className="custom_check">
//                                 <input
//                                   type="checkbox"
//                                   checked={row[column]}
//                                   onChange={() =>
//                                     handleCheckboxChange(row.module, column)
//                                   }
//                                 />
//                                 <span className="checkmark"></span>
//                               </label>
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// MOdal

import React, { useEffect, useRef, useState } from "react";
import { AllFormsUpperphoto, Applogo, profileLogo } from "../../../Routes/ImagePath";
import { DatePicker, Modal } from "antd";
import { Radio } from "react-feather";
import { useNavigate } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

export const AddBrokerModal = ({ BrokerDataFetchFunc, onClose }) => {
  const fileInputRef = useRef(null);

  const AllFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      console.log("id", id);
      const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });

      console.log("response", response);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFileLoginData();
  }, []);

  const [radioValue, setRadioValue] = useState(false);

  const [loading, setLoading] = useState(false);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: Number,
    Name: "",
    Mobile: "",
    // Purpose: Number,
    IsPurposeMet: false,
    LoanNumber: "",
    Selfie: null,
    Latitude: "",
    Longitude: "",
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData({ ...LocalFormData, Selfie: file });
  };

  const handleRadioChange = (e) => {
    setRadioValue(e.target.value === "true");
  };

  const handleDateChange = (date) => {
    setLocalFormData({ ...LocalFormData, VisitDate: date });
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...LocalFormData,
          Latitude: latitude,
          Longitude: longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // console.log("location",location?.latitude)

  const HandleSubmit = async () => {
    // Form validation
    if (!LocalFormData.BranchId) {
      ErrorToast("Please select a branch.");
      return;
    }
    if (!LocalFormData.Name) {
      ErrorToast("Please enter the customer name.");
      return;
    }
    if (LocalFormData.Mobile.length !== 10) {
      ErrorToast("Mobile Number must be exactly 10 digits.");
      return;
    }
    if (!LocalFormData.LoanNumber) {
      ErrorToast("Please enter the loan number.");
      return;
    }
    if (!LocalFormData.Selfie) {
      ErrorToast("Please upload a document.");
      return;
    }
    if (LocalFormData.IsPurposeMet === "") {
      ErrorToast("Please select whether the purpose was met.");
      return;
    }
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
    formData.append("LoanNumber", LocalFormData.LoanNumber);
    formData.append("Selfie", LocalFormData.Selfie);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);
  
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/BrokerVisit`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      BrokerDataFetchFunc();
      resetForm();
      SuccessToast("Broker Data Submitted Successfully");
      onClose();
      console.log(response);
    } catch (error) {
      ErrorToast("An Error Occurred While Submitting the Form.");
      console.error(error.message);
    }
  
    setLoading(false);
  };
  

  const resetForm = () => {
    setLocalFormData({
      BranchId: Number,
      Name: "",
      Mobile: "",
      // Purpose: Number,
      IsPurposeMet: false,
      LoanNumber: "",
      Selfie: null,
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const [allbranch, setAllBranch] = useState("");

  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      // console.log("response",response.data.data)
      setAllBranch(response.data.data);
    } catch (error) {
      console.log("object", error);
    }
  };
  console.log(allbranch);

  useEffect(() => {
    AllBranchName();
  }, []);

  const validateMobileNumber = (number) => {
    const regex = /^[0-9]{0,10}$/;
    return regex.test(number);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (validateMobileNumber(value)) {
      setLocalFormData({
        ...LocalFormData,
        Mobile: value,
      });
    }
  };

  return (
    <>
      <Modal
        title={<h4>Broker Visit</h4>}
        open={true}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <div
            className="d-flex justify-content-between align-items-center"
            key="footer"
          >
            <button className="btn btn-danger submit-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary submit-btn"
              onClick={HandleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>,
        ]}
        width={600}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <div className="profile-image text-center mt-4 mb-4">
            <img
              src={AllFormsUpperphoto}
              alt="Profile"
              className="img-fluid rounded-circle"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Branch <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={LocalFormData.BranchId}
                        onChange={(e) =>
                          setLocalFormData({
                            ...LocalFormData,
                            BranchId: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Branch</option>
                        {allbranch &&
                          allbranch.length > 0 &&
                          allbranch.map((res) => (
                            <option value={res.id}>{res.name}</option>
                          ))}
                        {/* Add more branches as needed */}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Customer Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        value={LocalFormData.Name}
                        onChange={(e) =>
                          setLocalFormData({
                            ...LocalFormData,
                            Name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label">
                      Upload Document <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      accept="image/*"
                      // value={LocalFormData.Selfie}
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Mobile <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        value={LocalFormData.Mobile}
                        onChange={handleMobileChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Loan No.<span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        value={LocalFormData.LoanNumber}
                        onChange={(e) =>
                          setLocalFormData({
                            ...LocalFormData,
                            LoanNumber: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label className="col-form-label">
                      Purpose Met <span className="text-danger">*</span>
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        value="true"
                        checked={LocalFormData.IsPurposeMet === true}
                        onChange={(e) =>
                          setLocalFormData({
                            ...LocalFormData,
                            IsPurposeMet: e.target.value === "true",
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault1"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        value=""
                        checked={LocalFormData.IsPurposeMet === false}
                        onChange={(e) =>
                          setLocalFormData({
                            ...LocalFormData,
                            IsPurposeMet: e.target.value === "true",
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault2"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </form>
        </div>
      </Modal>
    </>
  );
};
